import Close from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import { ButtonProps } from '@mui/material/Button';
import { createLink, LinkComponent } from '@tanstack/react-router';
import React from 'react';

type MUIButtonLinkProps = ButtonProps<'a'>;

const MUIButtonLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  MUIButtonLinkProps
>((props, ref) => (
  <IconButton
    aria-label='close'
    ref={ref}
    component='a'
    {...props}
    color='inherit'
  >
    <Close />
  </IconButton>
));

MUIButtonLinkComponent.displayName = 'MUIButtonLink';

const CreatedButtonLinkComponent = createLink(MUIButtonLinkComponent);

export const CloseButtonLink: LinkComponent<typeof MUIButtonLinkComponent> = (
  props,
) => {
  return (
    <Box
      sx={{
        color: 'common.white',
        border: '1px solid white',
        display: 'flex',
        borderRadius: 10,
      }}
    >
      <CreatedButtonLinkComponent preload={'intent'} {...props} />
    </Box>
  );
};
